// contract.api.ts
import api from '@/shared/api/api';
import {
  Contract,
  PaginatedContractsResponse,
  GetContractsParams,
  CreateContractPayload,
  UpdateContractPayload,
  ContractFile,
} from '../utils/types';

export const contractApi = {
  list: async (
    params?: GetContractsParams,
    signal?: AbortSignal
  ): Promise<PaginatedContractsResponse> => {
    const query = Object.fromEntries(
      Object.entries(params ?? {}).filter(([, v]) => v !== undefined && v !== 'all')
    );

    return await api<PaginatedContractsResponse>({
      url: '/v1/contracts',
      method: 'GET',
      params: query,
      signal,
    });
  },

  get: async (id: string, signal?: AbortSignal): Promise<Contract> => {
    return api<Contract>({
      url: `/v1/contracts/${id}`,
      method: 'GET',
      signal,
    });
  },

  create: async (payload: CreateContractPayload): Promise<Contract> => {
    const { file, status, ...rest } = payload; // upload é separado
    return api<Contract>({
      url: '/v1/contracts',
      method: 'POST',
      data: {
        ...rest,
        status: status ?? 'PENDING_SIGNATURE',
      },
    });
  },

  update: async (id: string, data: UpdateContractPayload): Promise<Contract> => {
    const { file, ...rest } = data; // upload separado
    return api<Contract>({
      url: `/v1/contracts?id=${id}`,
      method: 'POST',
      data: rest,
    });
  },

  remove: async (id: string): Promise<{ id: string; deletedAt: string }> => {
    return api({
      url: `/v1/contracts/${id}`,
      method: 'DELETE',
    });
  },

  uploadFile: async (id: string, file: File): Promise<ContractFile> => {
    const form = new FormData();
    form.append('file', file, file.name);
    // não force Content-Type; deixe o Axios setar o boundary
    return api<ContractFile>({
      url: `/v1/contracts/${id}/upload`,
      method: 'POST',
      data: form,
      // headers: { 'Content-Type': 'multipart/form-data' }, // opcional; axios define sozinho
    });
  },
};
